import React from 'react';

import ExamLink from '@components/libraryV2/ExamLink';
import { EXAMS } from '@constants/exams';

const ExamLinks = (props) => {
  const { className, withCard } = props;

  return EXAMS.map((exam) => {
    return (
      <ExamLink
        key={exam.name}
        className={className}
        name={exam.name}
        product={exam.product}
        withCard={withCard}
      />
    );
  });
};

export default ExamLinks;
